import { Avatar } from '@/ui/Avatars/Avatar';
import { LiquidityProviderAvatar } from '@/ui/Avatars/LiquidityProviderAvatar';
import { ArrowLeftLarge } from '@/ui/Icons/ArrowLeftLarge';
import { ChevronRightIcon } from '@/ui/Icons/ChevronRightIcon';
import { SwapIcon } from '@/ui/Icons/SwapIcon';

import { StyledParagraph } from '../../../SwapTokens/utils';

export function TransactionModuleCell() {
  return (
    <div
      className="-mb-1.5 border border-token-gray-300 border-b-0 bg-primitive-basic-white rounded-t-[20px] mt-14 desktop:mr-[70px] px-[22px] pt-5 text-center relative left-1/2 desktop:left-0 w-full self-start min-w-[310px] max-w-[440px] transform -translate-x-1/2 desktop:translate-x-0 desktop:mt-5"
      style={{
        boxShadow:
          '0px 1.71681px 3.43363px 0px rgba(0, 0, 0, 0.02), 0px 17.16814px 60.0885px 0px rgba(0, 0, 0, 0.06), 0px 1.71681px 10.30089px 0px rgba(0, 0, 0, 0.03)',
      }}
    >
      <ArrowLeftLarge className="absolute top-4 left-4" />
      <StyledParagraph className="leading-4 font-medium text-token-gray-1600 mb-5">
        Quote <span className="text-token-gray-800">expires in 20s</span>
      </StyledParagraph>
      <div className="flex relative ml-0 mr-0 mb-6 left-[50%] min-w-[300px] transform -translate-x-[50%]">
        <div className="items-center bg-token-gray-200 rounded-lg flex flex-col justify-center text-center border-primitive-basic-white border-2 border-solid relative pt-8 pb-5 w-[195px]">
          <Avatar src="/images/crosschain/tokens/usdc.svg" alt="usdc" size={40} />
          <span className="font-medium text-token-gray-1600 mt-6 mb-1">253.63 USDC</span>
          <span className="text-300 leading-5 text-token-gray-800">$253.44</span>
          <ChevronRightIcon
            className="absolute w-[52px] h-[52px] border-primitive-basic-white border-4 rounded-full bg-token-gray-200 z-10 p-4 top-[50%] transform -translate-y-[50%]"
            style={{ right: '-26px' }}
          />
        </div>
        <div className="items-center bg-token-gray-200 rounded-lg flex flex-col justify-center text-center border-primitive-basic-white border-2 border-solid relative pt-8 pb-5 w-[195px]">
          <Avatar src="/images/chains/eth.svg" alt="Eth" size={40} />
          <span className="font-medium text-token-gray-1600 mt-6 mb-1">0.06 ETH</span>
          <span className="text-300 leading-5 text-token-gray-800">$253.44</span>
        </div>
      </div>
      <div className="flex justify-between w-full text-token-gray-800 mb-[14px] relative">
        <span className="text-token-gray-800 text-300 leading-5">Liquidity provider</span>
        <span className="font-medium text-token-gray-1600 text-300 leading-4 flex items-center">
          <LiquidityProviderAvatar name="0x" size={20} alt="0x liquidity source" className="mr-1" />
          0x RFQ
        </span>
      </div>
      <div className="flex justify-between w-full text-token-gray-800 mb-[14px]">
        <span className="text-token-gray-800 text-300 leading-5">Rate</span>
        <span className="font-medium text-token-gray-1600 text-300 leading-4 flex items-center">
          <SwapIcon className="text-token-gray-800 mr-3" />1 ETH = 1562.76 USDC ($1562.77)
        </span>
      </div>
      <div className="flex justify-between w-full text-token-gray-800 mb-0 relative">
        <span className="text-token-gray-800 text-300 leading-5">Ethereum fees</span>
        <span className="font-medium text-token-gray-1600 text-300 leading-4">$23</span>
        <div
          className="absolute w-full h-[14px] bottom-0"
          style={{
            background: 'linear-gradient(0deg, #F6F6F7 0%, rgba(246, 246, 247, 0.00) 61.04%)',
          }}
        />
      </div>
    </div>
  );
}
